import { render, staticRenderFns } from "./SchoolInformationForm.vue?vue&type=template&id=2256251a&scoped=true"
import script from "./SchoolInformationForm.vue?vue&type=script&lang=js"
export * from "./SchoolInformationForm.vue?vue&type=script&lang=js"
import style0 from "./SchoolInformationForm.vue?vue&type=style&index=0&id=2256251a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256251a",
  null
  
)

export default component.exports